import React from 'react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { rows } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-231" data-mp="1nopn93i0bj2e">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-232" data-mp="1nrlmcv5lcdsf">
        <SectionTag icon="✨" tone="primary" data-id="element-233" data-mp="1irprblevfwp0">
          La transformación
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-234" data-mp="2ffm2ubvgc1td">
          Terminas una clase y ya estás pensando qué hacer en la siguiente.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-235" data-mp="26nk5imgoj1nb">
          Tienes que elegir ejercicios, organizar la secuencia y pensar cómo adaptarla a personas con
          diferentes capacidades y necesidades.
        </p>

        <div className="mt-6 rounded-2xl border border-accent/20 bg-accent/5 p-5 text-left sm:p-6" data-id="element-236" data-mp="2z5z7vtcvgh5a">
          <p className="font-heading text-sm font-semibold uppercase tracking-wide text-accent" data-id="element-237" data-mp="2ubuwmxwkpmye">
            Más que conocer el ejercicio
          </p>
          <p className="mt-2 text-sm leading-relaxed text-ink sm:text-base" data-id="element-238" data-mp="1a7izkh3waqcj">
            Y cuando llega el momento de enseñar, no basta con conocer el ejercicio. También necesitas
            identificar errores, dar indicaciones claras y saber cuándo facilitar o aumentar la
            dificultad.
          </p>
        </div>

        <p className="mt-6 text-base leading-relaxed text-ink sm:text-lg" data-id="element-239" data-mp="mg3u4fgtnsx2">
          Enciclopedia Pilates 360 reúne ejercicios, indicaciones, correcciones y progresiones
          organizados para ayudarte a preparar tus clases con mayor criterio y menos tiempo de búsqueda.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl px-4 sm:px-6" data-id="element-240" data-mp="hj3ykyhlm8k7">
        <ScrollHintTable minWidth="520px" data-id="element-241" data-mp="27ui238h9qsic">
          <table className="w-full text-left text-sm" data-id="element-242" data-mp="27vjfvkpo5t3r">
            <thead data-id="element-243" data-mp="2bx4w9g1ewpip">
              <tr className="border-b border-primary/10 bg-blush/60 text-xs uppercase tracking-wide text-ink" data-id="element-244" data-mp="2bvlcvgkglycp">
                <th className="px-5 py-3 font-semibold" data-id="element-245" data-mp="3kv4q95moijro">Antes</th>
                <th className="px-5 py-3 font-semibold" data-id="element-246" data-mp="3ftyt8vlzkacc">Después</th>
              </tr>
            </thead>
            <tbody data-id="element-247" data-mp="3bs3lp9dgp0q4">
              {rows.map((row, i) => <tr key={row.antes} className={i !== rows.length - 1 ? 'border-b border-primary/5' : ''} data-id="element-248" data-mp="3buq11v6lgkiw" data-mpi={i}>
                  <td className="bg-blush/20 px-5 py-4 align-top text-ink" data-id="element-249" data-mp="7enj46816tgx">{row.antes}</td>
                  <td className="bg-skyblue/40 px-5 py-4 align-top font-medium text-primary" data-id="element-250" data-mp="7ghtwrpl957a">{row.con}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>
      </div>
    </section>;
}